import { render, staticRenderFns } from "./BulkAdd.vue?vue&type=template&id=40f2e1d9&scoped=true&"
import script from "./BulkAdd.vue?vue&type=script&lang=js&"
export * from "./BulkAdd.vue?vue&type=script&lang=js&"
import style0 from "./BulkAdd.vue?vue&type=style&index=0&id=40f2e1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2e1d9",
  null
  
)

export default component.exports